// src/components/Auth/SocialSignInButtons.tsx

import { signInWithRedirect } from 'aws-amplify/auth';
import type React from 'react';
import type { JSX } from 'react';
import { Button } from 'reactstrap';

import { SignInWIthGoogleSvg, SignInWithMicrosoftSvg } from 'src/assets/icons/SiginInPageIcons';

const getAuthProviderDetails: {
  [key: string]: {
    buttonLabel: string;
    buttonIcon: JSX.Element;
  };
} = {
  microsoft_ad: {
    buttonLabel: 'Continue with Microsoft',
    buttonIcon: <SignInWithMicrosoftSvg />,
  },
  google: {
    buttonLabel: 'Continue with Google',
    buttonIcon: <SignInWIthGoogleSvg />,
  },
};

type Provider = {
  enabled: boolean;
  provider_name: string;
  provider: string;
};

type SocialSignInButtonsProps = {
  providers: Provider[];
};

const SocialSignInButtons: React.FC<SocialSignInButtonsProps> = ({ providers }) => {
  const enabledProviders = providers?.filter((p) => p?.enabled);

  if (!enabledProviders?.length) return null;

  const handleFederatedSignIn = (providerType: string, providerName: string) => {
    if (providerType === 'microsoft_ad') {
      signInWithRedirect({
        provider: { custom: providerName },
      });
    } else if (providerType === 'google') {
      signInWithRedirect({
        provider: 'Google',
      });
    }
  };

  return (
    <>
      {enabledProviders.map(({ provider_name, provider: providerType }) => {
        const authProvider = getAuthProviderDetails?.[providerType] || {};
        return (
          <div className="signin-sso" key={providerType}>
            <Button
              className="ls-button ls-button-secondary has-secondary btn-block"
              onClick={() => handleFederatedSignIn(providerType, provider_name)}
            >
              {authProvider?.buttonIcon}
              {authProvider?.buttonLabel}
            </Button>
          </div>
        );
      })}
      <div className="signin-or">OR</div>
    </>
  );
};

export default SocialSignInButtons;
